<template>
	<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="20" height="20" viewBox="0 0 20 20">
		<defs>
			<clipPath id="clip-path-429832">
				<rect
					id="Rectangle_14862"
					data-name="Rectangle 14862"
					width="20"
					height="20"
					transform="translate(60 764)"
					fill="#fff"
					stroke="#707070"
					stroke-width="1"
				/>
			</clipPath>
		</defs>
		<g id="Mask_Group_22273" data-name="Mask Group 22273" transform="translate(-60 -764)" clip-path="url(#clip-path-429832)">
			<g id="Group_44533" data-name="Group 44533" transform="translate(58.571 762.571)">
				<path
					id="Path_30438"
					data-name="Path 30438"
					d="M5.357,1.429A1.786,1.786,0,0,0,3.571,3.214V19.643a1.787,1.787,0,0,0,1.786,1.786H17.5a1.787,1.787,0,0,0,1.786-1.786v-7.5a3.571,3.571,0,0,0-3.571-3.571H13.929a1.786,1.786,0,0,1-1.786-1.786V5A3.571,3.571,0,0,0,8.571,1.429ZM7.143,14.286a.714.714,0,0,1,.714-.714H15A.714.714,0,0,1,15,15H7.857A.714.714,0,0,1,7.143,14.286Zm.714,2.143a.714.714,0,1,0,0,1.429h3.571a.714.714,0,1,0,0-1.429Z"
					fill="#5d5ee1"
					fill-rule="evenodd"
				/>
				<path
					id="Path_30439"
					data-name="Path 30439"
					d="M12.353,1.73A4.981,4.981,0,0,1,13.571,5V6.786a.357.357,0,0,0,.357.357h1.786a4.981,4.981,0,0,1,3.27,1.218A9.3,9.3,0,0,0,12.353,1.73Z"
					fill="#5d5ee1"
				/>
			</g>
		</g>
	</svg>
</template>

<script>
export default {
	name: 'DocsSvg',
};
</script>

<style scoped lang="scss"></style>
